import Cookies from 'js-cookie'
import add from 'date-fns/add'
import { isRejectedWithValue, isFulfilled } from '@reduxjs/toolkit'
import type { Middleware } from '@reduxjs/toolkit'

import { AUTH_SUCCESSFUL_KEY } from '@probatix/common/services/toolkit/auth/auth.constants'
import { getDomain } from '@probatix/common/utils/url'
import LocalStorage from '../utils/localStorage'
import { EXPIRY_OF_JWT_TOKEN_MINUTES } from '../config/app'
import { EXPIRATION_TIME_JWT, JWT } from '../services/services.constants'

export const activateQueryMiddleware: Middleware = () => (next) => (action) => {
  const auth = ['postAccountActivation', 'postSignedUpAccountActivation', 'postResetPassword']
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
  if (isRejectedWithValue(action)) {
    
    return next(action)
  } if (isFulfilled(action)) {
    // NOTE: middleware used for all of the probatix login services to ensure sign on for RTK Queries

    const token = action.payload?.token || action.payload?.jwt
    if (token) {
      const expiry = Date.now() + 1000 * 60 * Number(EXPIRY_OF_JWT_TOKEN_MINUTES)
      LocalStorage.set(JWT, token)
      LocalStorage.set(EXPIRATION_TIME_JWT, expiry)
    }

    if (auth.includes(action.meta.arg.endpointName)) {
      Cookies.set(AUTH_SUCCESSFUL_KEY, JSON.stringify(new Date()), {
        domain: `.${getDomain(action.meta.baseQueryMeta.request.url)}`,
        expires: add(new Date(), { days: 7 }),
      })

      return next(action)
    }
  }

  return next(action)
}
